import React from 'react';
import {
    Typography,
    Box,
    Grid,
    Divider,
} from '@mui/material';
import { useTranslations } from '@/lib/next-shim';
import { FormSubmission, GetMyInfosQuery } from '@/core/graphql/types';
import FormFieldValue from './FormFieldValue';

interface FormSubmissionDetailsProps {
    submission: GetMyInfosQuery['myInfos']['formSubmissions'][0];
}

const FormSubmissionDetails: React.FC<FormSubmissionDetailsProps> = ({
    submission,
}) => {
    const t = useTranslations();

    return (
        <Box sx={{ py: 2 }}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                {t('page.forms.submission.responses')}
            </Typography>
            <Divider sx={{ my: 2 }} />
            <Grid container spacing={3}>
                {submission.template.fields.map((field) => {
                    const response = submission.responses.find(
                        (r) => r.fieldId === field.id
                    );

                    return (
                        <Grid item xs={12} key={field.id}>
                            <Box>
                                <Typography variant="subtitle2" color="textSecondary">
                                    {field.label}
                                    {field.required && (
                                        <Typography
                                            component="span"
                                            color="error"
                                            sx={{ ml: 0.5 }}
                                        >
                                            *
                                        </Typography>
                                    )}
                                </Typography>
                                <Box sx={{ mt: 1 }}>
                                    <FormFieldValue
                                        field={field}
                                        value={response?.value || ''}
                                    />
                                </Box>
                            </Box>
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
};

export default FormSubmissionDetails; 